<template>
    <div class="fill-height d-flex align-center justify-space-around login-bg">
        <div class="d-flex flex-column align-center" style="width: 350px">
            <div class="pb-3">
                <img alt="logo" src="images/logo_full_dark-01.svg" width="500px"/>
            </div>

            <div class="pb-3 text-center text-h4 white--text" @click="checkValidity">
                Password Reset
            </div>

            <div class="pa-2" style="width: 100%" v-if="!passwordResetError">

                <div class="d-flex justify-center" v-if="validating">
                    <v-progress-circular
                            v-if="true"
                            :size="40"
                            :width="2"
                            color="primary"
                            indeterminate
                    />
                </div>

                <template v-else>
                    <v-form ref="passwordForm" @submit="$event.preventDefault()" autocomplete="new-password">
                        <v-text-field
                                ref="passwordField"
                                :readonly="!ready"
                                color="primary"
                                dark
                                outlined
                                dense
                                prepend-inner-icon="mdi-key-variant"
                                placeholder="Password"
                                autocomplete="new-password"
                                :disabled="resettingPassword"
                                v-model="password1"
                                type="password"
                                :rules="[validationRules.required, validationRules.upperCase, validationRules.lowerCase, validationRules.numeric, validationRules.specialCharacter, validationRules.min6Characters]"
                        />
                        <v-text-field
                                :readonly="!ready"
                                color="primary"
                                dark
                                outlined
                                dense
                                prepend-inner-icon="mdi-key-variant"
                                placeholder="Confirm Password"
                                :disabled="resettingPassword"
                                v-model="password2"
                                type="password"
                                :rules="[validationRules.required, passwordsMatch]"
                                autocomplete="new-password"
                        />
                    </v-form>

                    <div class="d-flex flex-column align-center justify-center">
                        <div>
                            <v-btn
                                    elevation="2"
                                    color="primary"
                                    outlined
                                    small
                                    :loading="resettingPassword"
                                    :disabled="resettingPassword"
                                    @click="changePassword"
                            >
                                Reset Password
                            </v-btn>
                        </div>
                    </div>
                </template>
            </div>

            <div v-else class="overline amber--text">
                {{passwordResetError}}
            </div>

        </div>
    </div>


</template>

<script>

import {mapActions} from 'vuex'
import AppTotpSetup from "@/components/Login/AppTotpSetup";
import {initializeRequestAuth, initializeSite} from '@/core/request'
import {validationRules} from "@/core/codeFunctions";

export default {
    components: {AppTotpSetup},
    props: {},
    data() {
        return {
            ready: false,
            con: console,
            link: (() => (new URL(window.location)).searchParams.get("link"))(),
            user: (() => (new URL(window.location)).searchParams.get("user"))(),
            password1: null,
            password2: null,
            resettingPassword: false,
            validationRules: validationRules,
            validating: true,
            passwordResetError: null
        }
    },
    mounted() {
        this.checkValidity();
    },
    methods: {
        async checkValidity() {
            try {
                this.validating = true;
                const {valid} = await this.$newReq('POST', `login/validatePasswordReset`, {
                    link: this.link,
                    userId: this.user
                }, false)
                if (!valid)
                    this.passwordResetError = 'Invalid/Expired Password Reset Link'

                setTimeout(() => {
                    this.ready = true;
                    this.$refs.passwordField.focus()
                }, 500)

                this.validating = false;
            } catch (e) {
                this.validating = false;
            }
        },

        async changePassword() {
            try {
                if (!this.$refs.passwordForm.validate())
                    return;
                this.resettingPassword = true;

                const {status} = await this.$newReq('POST', `login/passwordReset`, {
                    link: this.link,
                    userId: this.user,
                    password: this.password1
                }, false)

                if (status === 'success')
                    window.location.assign(`${window.location.protocol}//${window.location.hostname}`)
                else
                    this.passwordResetError = 'Password Reset Failed'
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.resettingPassword = false;
            }
        },

        passwordsMatch(val) {
            if (!val)
                return 'Required Value'
            if (val !== this.password1)
                return 'Passwords do not match'
            return true
        }
    },
    computed: {},
}
</script>

<style scoped>

.login-bg {
    height: 100%;
    width: 100vw;
    margin: 0;
    padding: 0;
    overflow: hidden;
    background: linear-gradient(135deg, rgba(0, 0, 0, 1) 0%, rgba(32, 32, 32, 1) 70%, rgba(45, 45, 45, 1) 70.1%, rgba(19, 19, 19, 1) 100%);
    font-weight: 200;
}

</style>